import { Component, OnInit} from '@angular/core';
import { MessageService } from 'primeng/api';
import { EleitorCsvDTO } from 'src/app/models/eleitorCsvDTO.model';
import { EleitorDTO } from 'src/app/models/eleitorDTO.model';
import { NewEleitorDTO } from 'src/app/models/newEleitorDTO.model';
import { EleitorService } from 'src/app/services/eleitor.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/utils/utils';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { EleitorComponent } from 'src/app/pages/gestor/parametrizacoes/eleitor/eleitor.component'
import { Ufs } from 'src/app/models/enums/uf-enum';
import { sha256 } from 'js-sha256';
import { NullAstVisitor } from '@angular/compiler';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Page } from 'src/app/models/page.model';

@Component({
  selector: 'app-massa-eleitor',
  templateUrl: './eleitor-csv-import.component.html',
  styleUrls: ['./eleitor-csv-import.component.css'],
})
export class EleitorCsvComponent implements OnInit {
  public eleitoresCsv: EleitorCsvDTO[] = [];
  idEleicao: any;
  idGestor: number;
  token: any;
  eleitores: EleitorDTO[];
  editandoEleitor: boolean = false;
  idEleitorEditando: any;
  newEleitorDTO: NewEleitorDTO = new NewEleitorDTO();
  newEleitores: NewEleitorDTO[] = [];
  eleitoresValidacao: NewEleitorDTO[] = [];
  criticaValidacao: any = [];
  enviados: any = [];
  duplicados: any = [];
  eleitoresSemPlano: any = [];
  eleicao: any;
  ativaNavValidacao: boolean = false;
  ativaNavEnviar: boolean = false;
  ativaNavEnviados: boolean = false;
  ativaNavDuplicados: boolean = false;
  ativaNavSemPlano: boolean = false;
  ufs: any[] = [];
  loader = this.loadingBar;
  public totalRegistros: number = 0;
  public registrosProcessados: number = 0;
  temPlano: boolean = false;

  constructor(
    private eleicaoService: EleicaoService,
    private eleitorService: EleitorService,
    private eleitorComponent: EleitorComponent,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    public utils: Utils,
    private loadingBar: LoadingBarService
  ) { }

  
  async ngOnInit() {

    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.eleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.idGestor = JSON.parse(sessionStorage.getItem("infoGestor")).id;
    this.token = sessionStorage.getItem("token");
    this.temPlano = this.eleicao.temPlanos;
    for (let item in Ufs) {
      if (isNaN(Number(item))) {
        this.ufs.push(item);
      }
    }
  }

  validaNavTab() {
    if (this.criticaValidacao.length > 0 && this.duplicados.length == 0 && this.enviados.length == 0) {
      this.ativaNavValidacao = true;
    } else {
      this.ativaNavValidacao = false;
    }

    if (this.criticaValidacao.length == 0 && this.newEleitores.length > 0) {
      this.ativaNavEnviar = true;
    } else {
      this.ativaNavEnviar = false;
    }
  }

  validaNavTabAposSalvar() {
    if (this.duplicados.length > 0) {
      this.ativaNavDuplicados = true;
      this.ativaNavValidacao = false;
      this.ativaNavEnviar = false;
    } else {
      this.ativaNavDuplicados = false;
    }

    if (this.duplicados.length == 0 && this.enviados.length > 0) {
      this.ativaNavEnviados = true;
      this.ativaNavValidacao = false;
      this.ativaNavEnviar = false;
    } else {
      this.ativaNavEnviados = false;
    }
  }

  okImportar(element) {
    this.spinner.show();
    if (this.enviados.length > 0) {
      this.enviados = [];
    }
    if (this.duplicados.length > 0) {
      this.duplicados = [];
    }
    if (this.eleitoresValidacao.length > 0) {
      this.eleitoresValidacao = [];
    }
    if (this.criticaValidacao.length > 0) {
      this.criticaValidacao = [];
    }
    if (this.eleitoresSemPlano.length > 0) {
      this.eleitoresSemPlano = [];
    }
    if (this.newEleitores.length > 0) {
      this.newEleitores = [];
    }
    element.value = '';
    this.eleicaoService.findAllEleitoresByEleicaoId(this.idEleicao, this.token);
    this.spinner.hide();
  }

  zerarInputFile(element) {
    if (element) {
      element.value = '';
    }
    this.newEleitores = [];
    this.eleitoresValidacao = [];
    this.criticaValidacao = [];
    this.eleitoresSemPlano = [];
    this.duplicados = [];
  }

  importarList() {
    this.bulkInsertEleitores(this.newEleitores, this.token);
  }

  async bulkInsertEleitores(eleitores: NewEleitorDTO[], token: any) {
    const state = this.loader;
    state.start(0);
  
    this.totalRegistros = eleitores.length;
    this.registrosProcessados = 0;  
    const batchSize = 200; // Quantidade de eleitores enviados por vez
    let count = 0;
  
    try {
      for (let i = 0; i < this.totalRegistros; i += batchSize) {
        // Dividir em batches
        const batch = eleitores.slice(i, i + batchSize);
        const resp: any = await this.eleitorService.bulkInsertEleitores(batch, token);
        this.registrosProcessados += batch.length;
        this.enviados = [...this.enviados, ...(resp.enviados || [])];
        this.duplicados = [...this.duplicados, ...(resp.duplicados || [])];
        state.set((this.registrosProcessados / this.totalRegistros) * 100);
      }
      this.newEleitores = [];
      this.validaNavTabAposSalvar();

      if (this.registrosProcessados >= this.totalRegistros) {
        this.eleitorComponent.buscarEleitoresPorEleicaoIdPage(10, 0);
        this.messageService.add({
          key: 'toast',
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'Eleitores enviados com sucesso!',
        });
      }
      
    } catch (error) {
      this.messageService.add({
        key: 'toast',
        severity: 'error',
        summary: 'Atenção',
        detail: error.message || error,
      });
    } finally {
      state.complete(); // Finaliza o loader
    }
  }
  
  

  // CSV
  importarCsv(event) {
    this.spinner.show();
    this.zerarInputFile(null);

    let arquivos = event.srcElement.files;

    if (this.validaTipoArquivo(arquivos[0])) {
      let input = event.target;
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);
      
      fileReader.onload = () => {
        let csvData = fileReader.result;
        let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
        let headersRow = this.utils.getHeaderArray(csvRecordsArray);
        this.eleitoresCsv = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
        this.eleitoresCsvToNewEleitores(this.eleitoresCsv);
        this.validaNavTab();
      };

      fileReader.onerror = () => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Ocorreu um erro ao tentar ler o arquivo!' });
      };

    } else {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'O arquivo selecionado não é um .csv válido!' });
      this.fileReset();
    }
    this.spinner.hide();
  }

  validaTipoArquivo(file: any) {
    return file.name.endsWith(".csv");
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = csvRecordsArray[i].split(';');
      if (curruntRecord.length == headerLength) {
        let eleitorCsv: EleitorCsvDTO = new EleitorCsvDTO();
        eleitorCsv.login = curruntRecord[0].trim();
        eleitorCsv.senha = curruntRecord[1].trim();
        eleitorCsv.plano = curruntRecord[2].trim();
        eleitorCsv.estado = curruntRecord[3].trim();
        eleitorCsv.email = curruntRecord[4].trim();
        eleitorCsv.auth1 = curruntRecord[5].trim();
        eleitorCsv.auth2 = curruntRecord[6].trim();
        eleitorCsv.agrupador = curruntRecord[7].trim();
        csvArr.push(eleitorCsv);
      }
    }
    return csvArr;
  }

  fileReset() {
    this.eleitoresCsv = [];
  }

  existeEstado(estado) {
    estado = estado.normalize('NFD').replace(/([\u0300-\u036f]|[^a-zA-Z])|[" "]/g, '');
    if (this.ufs.includes(estado)) {
      return true
    }
    return false
  }

  registrarCriticasImportacao(eleitor: NewEleitorDTO, critica: any) {
    this.eleitoresValidacao.push(eleitor);
    const eleitorCriticado = eleitor;
    this.criticaValidacao.push({ eleitorCriticado, critica: critica });
    return this.criticaValidacao

  }

  eleitoresCsvToNewEleitores(eleitoresCsv: EleitorCsvDTO[]) {
    const expressaoRegular = /[^A-Za-z0-9\@\.\_\-]/g;
    const expressaoRegularEmail = /\S+@\S+\.\S+/;
    
    // Cria um conjunto para armazenar logins únicos
    const loginsExistentes = new Set<string>();

    for (let eleitor of eleitoresCsv) {
        // Cria uma nova instância do DTO para cada registro
        const eleitorDTO = new NewEleitorDTO();
        eleitorDTO.login = eleitor.login;
        eleitorDTO.email = eleitor.email;
        eleitorDTO.senha = eleitor.senha? sha256.update(eleitor.senha).hex() : null; // aplicando 1ª criptografia de senha
        eleitorDTO.auth1 = eleitor.auth1;
        eleitorDTO.auth2 = eleitor.auth2;
        eleitorDTO.plano = eleitor.plano;
        eleitorDTO.agrupador = eleitor.agrupador;
        eleitorDTO.eleicao = { id: this.idEleicao };
        eleitorDTO.idGestor = this.idGestor;

        if (!eleitor.estado || eleitor.estado.trim() === '') {
            eleitorDTO.estado = "NAO_DECLARADO";
        } else {
            eleitorDTO.estado = eleitor.estado.toUpperCase();
        }

        // Validações
        if (!eleitorDTO.login) {
            this.registrarCriticasImportacao(eleitorDTO, "Validação 1.");
        } else if (expressaoRegular.test(eleitorDTO.login)) {
            this.registrarCriticasImportacao(eleitorDTO, "Validação 2 ou 3.");
        } else if ((eleitorDTO.senha == null || eleitorDTO.senha === '') && !this.eleicao.acessoIntegracao) {
            this.registrarCriticasImportacao(eleitorDTO, "Validação 4.");
        } else if (!this.existeEstado(eleitorDTO.estado) && eleitorDTO.estado !== "NAO_DECLARADO") {
            this.registrarCriticasImportacao(eleitorDTO, "Validação 5.");
        } else if (eleitorDTO.email && !expressaoRegularEmail.test(eleitorDTO.email)) {
            this.registrarCriticasImportacao(eleitorDTO, "Validação 6.");
        } else if (
            this.utils.noWhitespaceValidatorString(eleitorDTO.auth1) ||
            this.utils.noWhitespaceValidatorString(eleitorDTO.auth2)
        ) {
            this.registrarCriticasImportacao(eleitorDTO, "Validação 7.");
        } else if (loginsExistentes.has(eleitorDTO.login)) {
            this.registrarCriticasImportacao(eleitorDTO, "Validação 8.");
        } else if (this.temPlano && ((!eleitorDTO.plano || eleitorDTO.plano === '') || (eleitorDTO.agrupador === null || eleitorDTO.agrupador === ''))) {
            this.eleitoresSemPlano.push(eleitorDTO);
        } else {
            // Caso passe em todas as validações, adiciona à lista de eleitores válidos
            this.newEleitores.push(eleitorDTO);
            loginsExistentes.add(eleitorDTO.login);
        }
    }
    this.totalRegistros = this.newEleitores.length
}

  salvarEleitoresSemPlano(){
    for (let eleitor of this.eleitoresSemPlano) {
      this.newEleitores.push(eleitor);
    }
    this.eleitoresSemPlano = [];
    this.ativaNavSemPlano = false;
    this.ativaNavEnviar = true;
  }


}
